import * as React from 'react';
import { rule } from 'p4-css';
var blockClass = rule({
    d: 'inline-block',
    ov: 'hidden',
    bdrad: '6px',
    maxW: '600px',
    w: '100%',
    '&>iframe': {
        d: 'block',
        ov: 'hidden',
        bd: 0,
        w: '100%',
        h: '360px',
    },
});
var latlngRegex = /@([\-0-9\.]+),([\-0-9\.]+)(?:[^\-0-9\.]|$)/;
var Gmaps = function (_a) {
    var url = _a.url, renderWrap = _a.renderWrap, renderVoid = _a.renderVoid;
    var matches = url.match(latlngRegex);
    if (!matches)
        return renderVoid();
    var omit = matches[0], lat = matches[1], lng = matches[2];
    return renderWrap(React.createElement("div", { className: blockClass },
        React.createElement("iframe", { allowFullScreen: true, src: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d21948.472927059174!2d".concat(encodeURIComponent(lng), "!3d").concat(encodeURIComponent(lat), "!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sch!4v1551898961513") })));
};
export default Gmaps;
//# sourceMappingURL=index.js.map